class SmoothScroll {
  constructor(speed) {
    this.speed = 1 / speed;

    const links = [...document.querySelectorAll('a[href*="#"]')];

    links.map((v, i) => {
      v.addEventListener("click", (e) => {
        e.preventDefault();
        try {
          const href = e.currentTarget.getAttribute("href");
          const matchs = href.match(/^#(?<id>.+)$/);

          if (matchs === null) throw new Error("NOT EXIST ANCHOR LINK");

          const target = document.getElementById(matchs.groups.id);

          if (!target) throw new Error("NOT EXISTS ANCHOR TARGET");
          this.start(target);
        } catch (e) {
          console.log(e);
        }
      });
    });
  }

  start(target) {
    let y = target.getBoundingClientRect().top + window.pageYOffset;
    let c = 0;
    let f = true;
    this.tick(this.tick, target, y, f, c, this.speed);
  }

  tick(proc, target, y, flag, current, speed) {
    if (flag === true) {
      let range = 1 / speed - 1;
      current += Math.round((y - current) * speed);
      window.scrollTo(0, current);

      if (document.body.clientHeight - window.innerHeight < current) {
        window.scrollTo(0, document.body.clientHeight);
      }
      if (y - range < current && current < y + range) {
        window.scrollTo(0, y);
      } else {
        window.setTimeout(proc, 10, proc, target, y, flag, current, speed);
      }
    }
  }
}
